const VARIACOES_ACUMULADAS = {
    D1: { id: 'd1', dia_base: 1, util: false, linear: false, over: false },
    D1U: { id: 'd1u', dia_base: 1, util: true, linear: false, over: false },
    D2: { id: 'd2', dia_base: 2, util: false, linear: false, over: false },
    D2U: { id: 'd2u', dia_base: 2, util: true, linear: false, over: false },
    D3: { id: 'd3', dia_base: 3, util: false, linear: false, over: false },
    D3U: { id: 'd3u', dia_base: 3, util: true, linear: false, over: false },
    D4: { id: 'd4', dia_base: 4, util: false, linear: false, over: false },
    D4U: { id: 'd4u', dia_base: 4, util: true, linear: false, over: false },
    D5: { id: 'd5', dia_base: 5, util: false, linear: false, over: false },
    D5U: { id: 'd5u', dia_base: 5, util: true, linear: false, over: false },
    D6: { id: 'd6', dia_base: 6, util: false, linear: false, over: false },
    D6U: { id: 'd6u', dia_base: 6, util: true, linear: false, over: false },
    D7: { id: 'd7', dia_base: 7, util: false, linear: false, over: false },
    D7U: { id: 'd7u', dia_base: 7, util: true, linear: false, over: false },
    D8: { id: 'd8', dia_base: 8, util: false, linear: false, over: false },
    D8U: { id: 'd8u', dia_base: 8, util: true, linear: false, over: false },
    D9: { id: 'd9', dia_base: 9, util: false, linear: false, over: false },
    D9U: { id: 'd9u', dia_base: 9, util: true, linear: false, over: false },
    D10: { id: 'd10', dia_base: 10, util: false, linear: false, over: false },
    D10U: { id: 'd10u', dia_base: 10, util: true, linear: false, over: false },
    D11: { id: 'd11', dia_base: 11, util: false, linear: false, over: false },
    D11U: { id: 'd11u', dia_base: 11, util: true, linear: false, over: false },
    D12: { id: 'd12', dia_base: 12, util: false, linear: false, over: false },
    D12U: { id: 'd12u', dia_base: 12, util: true, linear: false, over: false },
    D13: { id: 'd13', dia_base: 13, util: false, linear: false, over: false },
    D13U: { id: 'd13u', dia_base: 13, util: true, linear: false, over: false },
    D14: { id: 'd14', dia_base: 14, util: false, linear: false, over: false },
    D14U: { id: 'd14u', dia_base: 14, util: true, linear: false, over: false },
    D15: { id: 'd15', dia_base: 15, util: false, linear: false, over: false },
    D15U: { id: 'd15u', dia_base: 15, util: true, linear: false, over: false },
    D16: { id: 'd16', dia_base: 16, util: false, linear: false, over: false },
    D16U: { id: 'd16u', dia_base: 16, util: true, linear: false, over: false },
    D17: { id: 'd17', dia_base: 17, util: false, linear: false, over: false },
    D17U: { id: 'd17u', dia_base: 17, util: true, linear: false, over: false },
    D18: { id: 'd18', dia_base: 18, util: false, linear: false, over: false },
    D18U: { id: 'd18u', dia_base: 18, util: true, linear: false, over: false },
    D19: { id: 'd19', dia_base: 19, util: false, linear: false, over: false },
    D19U: { id: 'd19u', dia_base: 19, util: true, linear: false, over: false },
    D20: { id: 'd20', dia_base: 20, util: false, linear: false, over: false },
    D20U: { id: 'd20u', dia_base: 20, util: true, linear: false, over: false },
    D21: { id: 'd21', dia_base: 21, util: false, linear: false, over: false },
    D21U: { id: 'd21u', dia_base: 21, util: true, linear: false, over: false },
    D22: { id: 'd22', dia_base: 22, util: false, linear: false, over: false },
    D22U: { id: 'd22u', dia_base: 22, util: true, linear: false, over: false },
    D23: { id: 'd23', dia_base: 23, util: false, linear: false, over: false },
    D23U: { id: 'd23u', dia_base: 23, util: true, linear: false, over: false },
    D24: { id: 'd24', dia_base: 24, util: false, linear: false, over: false },
    D24U: { id: 'd24u', dia_base: 24, util: true, linear: false, over: false },
    D25: { id: 'd25', dia_base: 25, util: false, linear: false, over: false },
    D25U: { id: 'd25u', dia_base: 25, util: true, linear: false, over: false },
    D26: { id: 'd26', dia_base: 26, util: false, linear: false, over: false },
    D26U: { id: 'd26u', dia_base: 26, util: true, linear: false, over: false },
    D27: { id: 'd27', dia_base: 27, util: false, linear: false, over: false },
    D27U: { id: 'd27u', dia_base: 27, util: true, linear: false, over: false },
    D28: { id: 'd28', dia_base: 28, util: false, linear: false, over: false },
    D28U: { id: 'd28u', dia_base: 28, util: true, linear: false, over: false },
    D29: { id: 'd29', dia_base: 29, util: false, linear: false, over: false },
    D29U: { id: 'd29u', dia_base: 29, util: true, linear: false, over: false },
    D30: { id: 'd30', dia_base: 30, util: false, linear: false, over: false },
    D30U: { id: 'd30u', dia_base: 30, util: true, linear: false, over: false },
    D31: { id: 'd31', dia_base: 31, util: false, linear: false, over: false },
    D31U: { id: 'd31u', dia_base: 31, util: true, linear: false, over: false }
};

module.exports = VARIACOES_ACUMULADAS;
